export const ActivationStatusPending = 'PENDING';
export const ActivationStatusConfirmed = 'CONFIRMED';
export const ActivationStatusDeclined = 'DECLINED';
export const ActivationStatuses = [
    ActivationStatusPending,
    ActivationStatusConfirmed,
    ActivationStatusDeclined,
];
export const FlightLogStatusInitialized = 'INITIALIZED';
export const FlightLogStatusExecuting = 'EXECUTING';
export const FlightLogStatusPaused = 'PAUSED';
export const FlightLogStatusCompleted = 'COMPLETED';
export const FlightLogStatusIncompleted = 'INCOMPLETED';
export const FlightLogStatuses = [
    FlightLogStatusInitialized, // 0
    FlightLogStatusExecuting, // 1
    FlightLogStatusPaused, // 2
    FlightLogStatusCompleted, // 3
    FlightLogStatusIncompleted, // 4
];
export const GpsFixTypeNoFix = 'No fix';
export const GpsFixTypeNoFix1 = 'No fix';
export const GpsFixType2DFix = '2D fix';
export const GpsFixType3DFix = '3D fix';
export const GpsFixTypes = [
    GpsFixTypeNoFix, // 0
    GpsFixTypeNoFix1, // 1
    GpsFixType2DFix, // 2
    GpsFixType3DFix, // 3
];
export const GroupMemberOwnerRole = 'OWNER';
export const GroupMemberEditorRole = 'EDITOR';
export const GroupMemberViewRole = 'VIEWER';
export const GroupMemberRoles = [GroupMemberOwnerRole, GroupMemberEditorRole, GroupMemberViewRole];
export const GroupMemberRoleMap = {
    OWNER: GroupMemberOwnerRole,
    EDITOR: GroupMemberEditorRole,
    VIEWER: GroupMemberViewRole,
};
export const InvitationStatusPending = 'PENDING';
export const InvitationStatusAccepted = 'ACCEPTED';
export const InvitationStatusDeclined = 'DECLINED';
export const InvitationStatuses = [
    InvitationStatusPending,
    InvitationStatusAccepted,
    InvitationStatusDeclined,
];
export const MemberRoleSystemAdmin = 'SYSTEM_ADMIN';
export const MemberRoleTrafficController = 'TRAFFIC_CONTROLLER';
export const MemberRoleMember = 'MEMBER';
export const MemberRoles = [MemberRoleSystemAdmin, MemberRoleTrafficController, MemberRoleMember];
export const MemberRoleMap = {
    SYSTEM_ADMIN: 'SYSTEM_ADMIN',
    TRAFFIC_CONTROLLER: 'TRAFFIC_CONTROLLER',
    MEMBER: 'MEMBER',
};
export const SystemStatusUninitialized = 'Uninitialized';
export const SystemStatusBooting = 'Booting';
export const SystemStatusCalibrating = 'Calibrating';
export const SystemStatusStandby = 'Standby';
export const SystemStatusActive = 'Active';
export const SystemStatusCritical = 'Critical';
export const SystemStatusEmergency = 'Emergency';
export const SystemStatusPowerOff = 'Power off';
export const SystemStatuses = [
    SystemStatusUninitialized, // 0
    SystemStatusBooting, // 1
    SystemStatusCalibrating, // 2
    SystemStatusStandby, // 3
    SystemStatusActive, // 4
    SystemStatusCritical, // 5
    SystemStatusEmergency, // 6
    SystemStatusPowerOff, // 7
];
export const VehicleTypeDrone = 'DRONE';
export const VehicleTypeHoverbike = 'HOVERBIKE';
export const VehicleTypeAsv = 'ASV';
export const VehicleTypes = [VehicleTypeDrone, VehicleTypeHoverbike, VehicleTypeAsv];
export const VehicleCommandMoveVehicleGlobal = 'MOVE_VEHICLE_GLOBAL';
export const VehicleCommandMoveVehicleRelative = 'MOVE_VEHICLE_RELATIVE';
export const VehicleCommandRotateVehicleGlobal = 'ROTATE_VEHICLE_GLOBAL';
export const VehicleCommandRotateVehicleRelative = 'ROTATE_VEHICLE_RELATIVE';
export const VehicleCommandRotateGimbalGlobal = 'ROTATE_GIMBAL_GLOBAL';
export const VehicleCommandRotateGimbalRelative = 'ROTATE_GIMBAL_RELATIVE';
export const VehicleCommandTakePhoto = 'TAKE_PHOTO';
export const VehicleCommandStartPhotoInterval = 'START_PHOTO_INTERVAL';
export const VehicleCommandStopPhotoInterval = 'STOP_PHOTO_INTERVAL';
export const VehicleCommandStartVideoCapture = 'START_VIDEO_CAPTURE';
export const VehicleCommandStopVideoCapture = 'STOP_VIDEO_CAPTURE';
export const VehicleCommandManualControl = 'MANUAL_CONTROL';
export const VehicleCommandHoldPosition = 'HOLD_POSITION';
export const VehicleCommands = [
    VehicleCommandMoveVehicleGlobal,
    VehicleCommandMoveVehicleRelative,
    VehicleCommandRotateVehicleGlobal,
    VehicleCommandRotateVehicleRelative,
    VehicleCommandRotateGimbalGlobal,
    VehicleCommandRotateGimbalRelative,
    VehicleCommandTakePhoto,
    VehicleCommandStartPhotoInterval,
    VehicleCommandStopPhotoInterval,
    VehicleCommandStartVideoCapture,
    VehicleCommandStopVideoCapture,
    VehicleCommandHoldPosition,
];
export const VehicleModeNoop = undefined;
export const VehicleModeStabilze = 'Stabilize';
export const VehicleModeAcro = 'Acro';
export const VehicleModeAltHold = 'Alt hold';
export const VehicleModeAuto = 'Auto';
export const VehicleModeGuided = 'Guided';
export const VehicleModeLoiter = 'Loiter';
export const VehicleModeRTL = 'RTL';
export const VehicleModeCircle = 'Circle';
export const VehicleModeLand = 'Land';
export const VehicleModeDrift = 'Drift';
export const VehicleModeSport = 'Sport';
export const VehicleModeFlip = 'Flip';
export const VehicleModeAutoTune = 'Auto tune';
export const VehicleModePosHold = 'Pos hold';
export const VehicleModeBrake = 'Brake';
export const VehicleModeThrow = 'Throw';
export const VehicleModeAvoidADSB = 'Avoid ADSB';
export const VehicleModeGuidedNoGPS = 'Guided no GPS';
export const VehicleModeSmartRTL = 'Smart RTL';
export const VehicleModeFlowHold = 'Flow hold';
export const VehicleModeFollow = 'Follow';
export const VehicleModeZigzag = 'Zigzag';
export const VehicleModeSystemID = 'System ID';
export const VehicleModeAutoRotate = 'Auto rotate';
export const VehicleModeAutoRTL = 'Auto RTL';
export const VehicleModeTurtle = 'Turtle';
export const VehicleModes = [
    VehicleModeStabilze, // 0
    VehicleModeAcro, // 1
    VehicleModeAltHold, // 2
    VehicleModeAuto, // 3
    VehicleModeGuided, // 4
    VehicleModeLoiter, // 5
    VehicleModeRTL, // 6
    VehicleModeCircle, // 7
    VehicleModeNoop, // 8
    VehicleModeLand, // 9
    VehicleModeNoop, // 10
    VehicleModeDrift, // 11
    VehicleModeNoop, // 12
    VehicleModeSport, // 13
    VehicleModeFlip, // 14
    VehicleModeAutoTune, // 15
    VehicleModePosHold, // 16
    VehicleModeBrake, // 17
    VehicleModeThrow, // 18
    VehicleModeAvoidADSB, // 19
    VehicleModeGuidedNoGPS, // 20
    VehicleModeSmartRTL, // 21
    VehicleModeFlowHold, // 22
    VehicleModeFollow, // 23
    VehicleModeZigzag, // 24
    VehicleModeSystemID, // 25
    VehicleModeAutoRotate, // 26
    VehicleModeAutoRTL, // 27
    VehicleModeTurtle, // 28
];
export const WaypointActionTakeOff = 'TAKE_OFF';
export const WaypointActionLand = 'LAND';
export const WaypointActionStay = 'STAY';
export const WaypointActionMoveTo = 'MOVE_TO';
export const WayponitActions = [WaypointActionTakeOff, WaypointActionLand, WaypointActionStay, WaypointActionMoveTo];
export const isAltitudeRequired = (action) => [WaypointActionStay, WaypointActionMoveTo].includes(action);
export const isYawRequired = (_) => false;
export const isDurationRequired = (action) => action === WaypointActionStay;
export const isSpeedRequired = (action) => action !== WaypointActionTakeOff;
